import { Select } from "antd";
import { useEffect, useState } from "react";
import CypressTestIds from "../../../cypress/CypressTestIds";

interface ITagSearchInputProps {
    value?: string;
    loadingDataTags?: boolean;
    dataTags: IDataTag[];
    onChange?: (s: string) => void;
}

const { Option } = Select;

const TagSearchInput = ({ value, onChange, loadingDataTags, dataTags }: ITagSearchInputProps) => {
    const [selectedValues, setSelectedValues] = useState(value);

    useEffect(() => {
        setSelectedValues(value);
    }, [value]);

    const onTagsChange = (newValue: string) => {
        setSelectedValues(newValue);
        onChange && onChange(newValue);
    };

    return (
        <Select
            mode="tags"
            placeholder="Tag Search: search for a tags to add as a duplicate match"
            loading={loadingDataTags}
            value={selectedValues}
            onChange={onTagsChange}
            data-testid={CypressTestIds.DUPLICATE_SEARCH_CONFIG_TAG_SEARCH_SELECT}
        >
            {dataTags.map((dataTag, index) => (
                <Option key={dataTag.tagId} value={dataTag.tagName}>{`${dataTag.tagName}`}</Option>
            ))}
        </Select>
    );
};

export default TagSearchInput;
